"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var qs = require("qs");
var url_helpers_1 = require("../url_helpers");
var bind_1 = require("../bind");
var react_tracking_1 = require("react-tracking");
var tracker_1 = require("../tracker");
var csrf_form_1 = require("../csrf_form");
var form_group_with_checkbox_1 = require("./form_group_with_checkbox");
var form_group_with_input_1 = require("./form_group_with_input");
var COMPONENT_NAME = 'SigninForm';
var SigninForm = /** @class */ (function (_super) {
    tslib_1.__extends(SigninForm, _super);
    function SigninForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rememberMe = null;
        return _this;
    }
    SigninForm.prototype.handleSubmit = function (e) {
        var rememberMeElem = e.target.elements['user_session[remember_me]'];
        // Since we're using standard HTML form submit, we need to coerce
        // the react internal representation into standard booleans
        rememberMeElem.value = this.rememberMe.checked;
        this.props.tracking.trackEvent({
            interaction: tracker_1.SUBMIT,
            context: this.props.trackContext,
        });
    };
    SigninForm.prototype.authUrlParams = function () {
        return qs.stringify({
            redirect_to: this.props.redirectTo,
        });
    };
    SigninForm.prototype.renderHeader = function () {
        if (!this.props.shouldRenderHeader) {
            return null;
        }
        return (React.createElement("h4", { className: "signup-signin__header" }, I18n.t('commons.signupForm.signinHeader')));
    };
    SigninForm.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            this.renderHeader(),
            React.createElement(csrf_form_1.default, { action: "/authenticate?" + this.authUrlParams(), method: "post", onSubmit: this.handleSubmit, "data-disable-auto-validation": "true" // block forms.js handling
             },
                React.createElement(form_group_with_input_1.default, { label: I18n.t('commons.signupForm.emailLabel'), inputName: "user_session[login]", inputType: "email", autoComplete: "email", autoFocus: true, required: true }),
                React.createElement(form_group_with_input_1.default, { label: I18n.t('commons.signupForm.passwordLabel'), inputType: "password", inputName: "user_session[password]", required: true, autoComplete: "current-password" }),
                React.createElement("div", { className: "scaling-mtb-2" },
                    React.createElement("input", { type: "submit", value: I18n.t('commons.signupForm.logIn'), className: "button button--orange width-100" })),
                React.createElement(form_group_with_checkbox_1.default, { label: I18n.t('commons.signupForm.rememberMe'), inputName: "user_session[remember_me]", ref: function (r) { return _this.rememberMe = r; }, defaultChecked: true }),
                React.createElement("p", { className: "size-90 mt-1 align-center" },
                    I18n.t('commons.signupForm.forgotPassword'),
                    ' ',
                    React.createElement("a", { href: url_helpers_1.PASSWORD_RESET_PATH, target: "_blank", rel: "noopener noreferrer" }, I18n.t('commons.signupForm.passwordReset'))),
                React.createElement("hr", { className: "mtb-2" }),
                React.createElement("div", { className: "signup-signin__form__facebook" },
                    React.createElement("a", { className: "signup-signin__form__facebook__link", href: url_helpers_1.FACEBOOK_AUTH_PATH + "?" + this.authUrlParams() }, I18n.t('commons.signupForm.facebookSignin'))))));
    };
    SigninForm.defaultProps = {
        shouldRenderHeader: true,
        trackName: 'SigninForm',
    };
    tslib_1.__decorate([
        bind_1.default
    ], SigninForm.prototype, "handleSubmit", null);
    SigninForm = tslib_1.__decorate([
        react_tracking_1.default({ componentName: COMPONENT_NAME })
    ], SigninForm);
    return SigninForm;
}(React.Component));
exports.default = SigninForm;
//# sourceMappingURL=signin_form.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/signin_form.js
// module id = q88G
// module chunks = 20 21